/*
 * @LastEditors: zhanglinju
 */
/*
 * @LastEditors: zhanglinju
 */
import yxpapi from '@yxpapi';

const api = new yxpapi.PHPAPI({
    // 获取轮播图
    getrotationInfoList: {
        url: '/api/crm/preview/rotationInfo',
        method: 'get',
        options: {
            headers: {
                authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
                orgId: '1',
            },
            auth: false,
        },

    },
    // 获取栏目列表
    getcatalogList: {
        url: '/api/crm/preview/catalogList',
        method: 'get',
        options: {
            headers: {
                authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
                orgId: '1',
            },
            auth: false,
        },

    },
    // 获取栏目详情
    catalogDetail: {
        url: '/api/crm/preview/catalogDetail',
        method: 'get',
        options: {
            headers: {
                authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
                orgId: '1',
            },
            auth: false,
        },
    },
    // 获取code
    getSiteByCode: {
        url: '/api/crm/common/getSiteByCode',
        method: 'get',
        options: {
            headers: {
                authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
                orgId: '1',
            },
            auth: false,
        },
    },
    getPageManagePlugList: {
        url: '/api/crm/plug/list',
        method: 'get',
        options: {
            headers: {
                authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
                orgId: '1',
            },
            auth: false,
        },
    },
    getWebSiteAddress: {
        url: '/api/crm/common/getWebSiteAddress',
        method: 'get',
        options: {
            headers: {
                authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
                orgId: '1',
            },
            auth: false,
        },
    },
    getInfoCintent: {
        url: '/api/crm/website/content/getInfo',
        method: 'get',
        options: {
            headers: {
                authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
                orgId: '1',
            },
            auth: false,
        },
    },
    getWxurl: {
        url: 'https://wechat-api.anoah.com/api/wechat/getJsSdk',
        method: 'get',
        options: {
            auth: false,
            errorTip: false,
        },
    },
    // 分页获取内容列表
    getPageList: {
        url: '/api/crm/website/content/pageList',
        method: 'post',
        options: {
            headers: {
                authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
                orgId: '1',
                'Content-Type': 'application/json',
            },
            auth: false,
        },
    },
    // 获取友情链接列表
    getPartnerList: {
        url: '/api/crm/website/partner/list',
        method: 'post',
        options: {
            headers: {
                authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
                orgId: '1',
                'Content-Type': 'application/json',
            },
            auth: false,
        },
    },
    /* 获取站点信息 */
    websiteInfo: {
        url: '/api/crm/website/info',
        method: 'get',
        options: {
            headers: {
                authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
                orgId: '1',
            },
            auth: false,
        },
    },
    /* 站点栏目 */
    // 站点栏目树列表
    getTreeList: {
        url: '/api/crm/catalog/treeList',
        method: 'get',
        options: {
            headers: {
                authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
                orgId: '1',
            },
            auth: false,
        },
    },
    getColumnInfo: {
        url: '/api/crm/catalog/info',
        method: 'get',
        options: {
            headers: {
                authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
                orgId: '1',
            },
            auth: false,
        },
    },
    // 搜索下拉
    getSearchInfo: {
        url: '/api/crm/website/content/search',
        method: 'get',
        options: {
            headers: {
                authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
                orgId: '1',
            },
            auth: false,
        },
    },
    getNavigation: {
        url: '/api/crm/website/navigation/treeList',
        method: 'get',
        options: {
            headers: {
                authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
                orgId: '1',
            },
            auth: false,
            errorTip: false,
        },
    },
    // 轮播图列表
    getRotationList: {
        url: '/api/crm/rotation/list',
        method: 'get',
        options: {
            headers: {
                authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
                orgId: '1',
                'Content-Type': 'application/json',
            },
            auth: false,
            errorTip: false,
        },
    },
    // 栏目展示-栏目树
    web3CatalogTree: {
        url: '/api/crm/website/play/catalogTree',
        method: 'get',
        options: {
            headers: {
                authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
                orgId: '1',
                'Content-Type': 'application/json',
            },
            auth: false,
            errorTip: false,
        },
    },
    // 栏目展示-栏目下内容列表
    contentPageList: {
        url: '/api/crm/website/play/contentPageList',
        method: 'post',
        options: {
            headers: {
                authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
                orgId: '1',
                'Content-Type': 'application/json',
            },
            auth: false,
            errorTip: false,
        },
    },
    // 内容详情
    contentDetail: {
        url: '/api/crm/website/play/contentDetail',
        method: 'get',
        options: {
            headers: {
                authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
                orgId: '1',
                'Content-Type': 'application/json',
            },
            auth: false,
            errorTip: false,
        },
    },
    // 首页内容列表展示
    catalogContentList: {
        url: '/api/crm/website/play/catalogContentList',
        method: 'get',
        options: {
            headers: {
                authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
                orgId: '1',
                'Content-Type': 'application/json',
            },
            auth: false,
            errorTip: false,
        },
    },
    // 获取链接图标显示方式
    getLinkMode: {
        url: '/api/crm/website/select/label',
        method: 'get',
        options: {
            headers: {
                authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
                orgId: '1',
                'Content-Type': 'application/json',
            },
            auth: false,
            errorTip: false,
        },
    },
    // 获取链接列表
    getLinks: {
        url: '/api/crm/website/partner/pageList',
        method: 'post',
        options: {
            headers: {
                authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
                orgId: '1',
                'Content-Type': 'application/json',
            },
            auth: false,
            errorTip: false,
        },
    },
    // 获取应用详情列表
    listByCondition: {
        url: '/api/crm/website/app/listByCondition',
        method: 'get',
        before: (me, setParamFun) => {
            me.options.headers['orgId'] = window.yxpapi.store.getters['system/getWebSiteOrgId'];
            setParamFun(me);
        },
        options: {
            headers: {
                authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
                'Content-Type': 'application/json',
            },
            auth: false,
            errorTip: false,
        },
    },
    // 点击应用图标操作
    clickApp: {
        url: '/api/crm/website/app/clickEvent',
        method: 'get',
        before: (me, setParamFun) => {
            if (window.yxpapi.store.getters['global/isLogin']) {
                me.options.headers['orgId'] = window.yxpapi.store.getters['global/orgId'];
                me.options.headers['authorization'] = window.yxpapi.store.getters['global/loginInfo'].jwt;
                me.options.headers['userId'] = window.yxpapi.store.getters['global/loginInfo'].userId;
                me.options.headers['orgType'] = window.yxpapi.store.getters['global/loginInfo'].orgType;
            } else {
                me.options.headers['orgId'] = window.yxpapi.store.getters['system/getWebSiteOrgId'];
                me.options.headers['orgType'] = window.yxpapi.store.getters['system/getWebSiteOrgType'];
                me.options.headers['authorization'] = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8';
            }
            setParamFun(me);
        },
        options: {
            headers: {
                'Content-Type': 'application/json',
            },
            auth: false,
            errorTip: false,
        },
    },
    /* 第三方应用获取code */
    getCodeByToken: {
        url: window.yxpapiConfig.env === 'development' ? 'http://192.168.46.242:9142/api/open/oauth2/authorize/getCodeByToken' : 'https://openapis.anoah.com/api/open/oauth2/authorize/getCodeByToken',
        method: 'post',
    },
    // 统计内容的时长
    statisticsTime: {
        url: '/api/crm/website/play/saveHits',
        method: 'post',
        before: (me, setParamFun) => {
            me.options.errorTip = false;
            if (window.yxpapi.store.getters['global/isLogin']) {
                me.options.headers['orgId'] = window.yxpapi.store.getters['global/orgId'];
                me.options.headers['authorization'] = window.yxpapi.store.getters['global/loginInfo'].jwt;
            } else {
                me.options.headers['orgId'] = window.yxpapi.store.getters['system/getWebSiteOrgId'];
                me.options.headers['authorization'] = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8';
            }
            setParamFun(me);
        },
        options: {
            headers: {
                'Content-Type': 'application/json',
            },
            auth: false,
            errorTip: false,
        },
    },
    // 目录轮播图列表
    getCatalogRotationList: {
        url: '/api/crm/catalog/rotation/list',
        method: 'get',
        options: {
            headers: {
                authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
                orgId: '1',
                'Content-Type': 'application/json',
            },
            auth: false,
            errorTip: false,
        },
    },

    /**
     * 线索保存(创建人：yuanxi)
     * http://yapi.dev.anoah.com/project/1160/interface/api/70968
     */
    collection: {
        url: '/api/crm/clue/save',
        method: 'post',
        options: {
            headers: {
                authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
                orgId: '1',
                'Content-Type': 'application/json',
            },
            auth: false,
            errorTip: false,
        },
    },
});
export default api;
